<template>
<div class="wrapper">
  <div class="container details">
    <div class="row">
      <div class="col-md-12"><h1>{{customer.data.name}}</h1></div>
    </div>
    <div class="row orderDetailsWrapper">
      <form class="formGeneratorWithColumns">
        <vue-form-generator tag="div" :schema="schema" :model="customer.data" />
      </form>
      <!--<div class="col-md-4" v-for="schemaGroup in schema.groups" :key="schemaGroup.id">
        <legend>{{ schemaGroup.legend }}</legend>
          <div class="wrapper" v-for="schemaField in schemaGroup.fields" :key="schemaField.id">
            <label>{{ schemaField.label }}</label>
              <p>{{customer.data[schemaField.model]}}</p>
          </div>
      </div>-->
    </div>
  </div>
   <CustomerPlaces :customerId="customer.id"/>
    <div class="orderButtonsWrapper container">
    <div class="row">
      <div class="col-md-12">
        <Button label="Spara" class="p-button-success" @click="onSave()" icon="pi pi-file" ></Button>
        <Button label="Tillbaka" @click="onCancel()"/>
      </div>
    </div>
  </div>
  <Toast position="topright" />
</div>
</template>

<script>
import CustomerPlaces from '@/components/Customers/CustomerPlacesList'
import VueFormGenerator from 'vue-form-generator'
import Dialog from 'primevue/dialog'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
export default {
  name: 'CustomerDetails',
  components: {
    CustomerPlaces,
    'vue-form-generator': VueFormGenerator.component,
    Toast,
    Button,
    Dialog
  },
  data () {
    return {
      customer: {},
      schema: {}
    }
  },
  mounted () {
    var url = '/api/customers/' + this.$route.params.id
    this.$http
      .get(url)
      .then(response => {
        this.customer = response.data.customer
        this.schema = response.data.schema
      })
      .catch(error => console.log(error))
  },
  methods: {
    onSave () {
      let message = 'Vill du spara kunden?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var url = '/api/customers/' + this.customer.id
          this.$http
            .put(url, {
              customer: {
                data: this._.omit(this.customer.data, 'submit')
              }
            })
            .then(response => {
              this.$toast.add({severity: 'success', summary: 'Kund sparad', life: 3000})
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on finish')
        })
    },
    onCancel () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Customers/CustomerDetails.vue